<div class="package-content">
  <div class="submittal-entries">
    @for (registryEntry of submittalPackage()?.entries; track $index; let index = $index) {
      <div class="submittal-item text-navy-900 font-normal text-size_m">
        <div class="item">
          <app-faded-text class="font-semibold text-size_xl">{{ registryEntry.item_description }}</app-faded-text>
          <app-faded-text class=""
            >{{ registryEntry?.custom_id }} - {{ registryEntry.spec_section }}
            {{ registryEntry.spec_description }}</app-faded-text
          >
        </div>
        <div class="item">
          @if (isEditMode()[index]) {
            <app-floating-textarea
              placeholder="Type notes here..."
              [ngModel]="editedRegistryEntryData()?.[index]?.note"
              (ngModelChange)="noteChanged(index, $event)"
              [name]="'notes-' + index"
              [verticalSpacing]="false"
              [rows]="2"
            >
            </app-floating-textarea>
          } @else if (registryEntry.note) {
            <div>
              {{ registryEntry.note }}
            </div>
          } @else {
            <div class="text-navy-700">No comments</div>
          }
        </div>
        <div class="item status-column">
          <app-status-block
            (click)="statusBlockClicked(index)"
            [status]="editedRegistryEntryData()?.[index]?.status"
            [class.cursor-pointer]="isEditMode()[index]"
            #statusBlockComponent="cdkOverlayOrigin"
            cdkOverlayOrigin
          >
            @if (isEditMode()[index]) {
              <span rightIcon>
                @if (isStatusDropdownShown()[index]) {
                  <span
                    class="icon-arrow-right-light inline-block -rotate-90 text-size_m text-color-white"
                    [class.text-navy-600]="!editedRegistryEntryData()?.[index]?.status"
                  ></span>
                } @else {
                  <span
                    class="icon-arrow-right-light inline-block rotate-90 text-size_m text-color-white"
                    [class.text-navy-600]="!editedRegistryEntryData()?.[index]?.status"
                  ></span>
                }
              </span>
            }
            <app-overlay-general
              [show]="isStatusDropdownShown()[index]"
              (showChange)="toggleStatusDropdown(index)"
              [trigger]="statusBlockComponent"
              [overlayPositions]="dropdownOverlayPositions()"
            >
              <div class="options-overlay-white flex flex-col max-h-64 overflow-y-auto w-[120px]">
                @for (status of statuses(); track status.value) {
                  <div
                    (click)="statusSelected(index, status.value)"
                    class="px-2 py-1 font-semibold text-size_l text-navy-900 cursor-pointer hover:bg-grey-200"
                  >
                    {{ status.label }}
                  </div>
                }
              </div>
            </app-overlay-general>
          </app-status-block>
          @if (submittalPackage()?.role === 'participant' || submittalPackage()?.role === 'owner') {
            <!--just a placeholder -->
            <div class="w-[24px] h-5"></div>
          } @else if (isEditMode()[index]) {
            <span
              appTooltip="Save Entry"
              (click)="saveEntry(index)"
              class="icon icon-box-checked text-green-600 hover:text-navy-700"
            ></span>
            <span
              appTooltip="Cancel Edit"
              (click)="cancelEdit(index)"
              class="icon icon-cancel-box-filled-x text-navy-400 hover:text-navy-700"
            ></span>
          } @else if (isRegistryEntriesLoading()[registryEntry.id]) {
            <app-loading-spinner class="icon" size="small"></app-loading-spinner>
          } @else if (submittalPackage()?.sent_to_owner_at) {
            <span [appTooltip]="packageLockTooltip()" class="icon icon-padlock-locked-filled text-grey-500"></span>
          } @else {
            <span
              [appTooltip]="
                submittalPackage().status === SUBMITTAL_PACKAGE_STATUS.OPEN
                  ? 'Edit Entry'
                  : 'Package is not open. Entries cannot be edited.'
              "
            >
              <span
                (click)="enterEditMode(index)"
                class="icon icon-pencil-block text-blue-700 hover:text-navy-700"
                [class.disabled]="submittalPackage().status !== SUBMITTAL_PACKAGE_STATUS.OPEN"
                [class.text-grey-500]="submittalPackage().status !== SUBMITTAL_PACKAGE_STATUS.OPEN"
              ></span>
            </span>
          }
        </div>
      </div>
    }
  </div>
  <div class="submittal-documents">
    @for (documentCategory of documentCategories(); track $index; let index = $index) {
      <div class="documents-column">
        <div class="column-header-container">
          <div class="column-header">
            <span class="flex-1">{{ documentCategory.label }}</span>
            <app-options-list-simple
              [show]="optionsListShown()[index]"
              (showChange)="optionsListShowChange(index, $event)"
              [actions]="documentCategoryOptions()[index]"
              [trigger]="trigger"
              (optionSelected)="optionSelected(documentCategory.value, index, $event)"
              [disabled]="!documentCategory.canBeEdited"
            >
              <app-arrow-button-box
                cdkOverlayOrigin
                #trigger="cdkOverlayOrigin"
                [direction]="optionsListShown()[index] ? 'up' : 'down'"
                [disabled]="!documentCategory.canBeEdited"
              ></app-arrow-button-box>
            </app-options-list-simple>
          </div>
        </div>
        <app-hidden-upload-input
          [allowMultipleFiles]="true"
          (filesChange)="filesChanged(documentCategory.value, $event)"
          #uploadHiddenInputComponent
        >
        </app-hidden-upload-input>
        <div class="document-list">
          @for (file of submittalPackage()?.files?.[documentCategory.value]; track file.id) {
            <app-file-card
              [file]="file"
              (iconClick)="documentCategory.canBeEdited && deleteFile(file, $event)"
              [iconName]="documentCategory.canBeEdited ? 'icon-minus-box' : 'icon-folded-file-download'"
            ></app-file-card>
          } @empty {
            <div class="text-center text-navy-900 text-size_m font-normal">No documents</div>
          }
        </div>
      </div>
    }
  </div>
</div>
